var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-info2 banner-fade-in"},[_c('div',{ref:"animate",staticClass:"banner-info2-content"},[_c('div',{staticClass:"title"},[_vm._v("BBG MOVE Travel")]),_c('div',{staticClass:"desc"},[_vm._v("Our all-inclusive journeys offer unparalleled service and meaningful experiences in China.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }